__turbopack_context__.v({
  "notFoundPage": "not-found-module-scss-module__8bFjwa__notFoundPage",
  "notFoundPage_button": "not-found-module-scss-module__8bFjwa__notFoundPage_button",
  "notFoundPage_description": "not-found-module-scss-module__8bFjwa__notFoundPage_description",
  "notFoundPage_icon": "not-found-module-scss-module__8bFjwa__notFoundPage_icon",
  "notFoundPage_search": "not-found-module-scss-module__8bFjwa__notFoundPage_search",
  "notFoundPage_title": "not-found-module-scss-module__8bFjwa__notFoundPage_title",
});
